









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SubMenuModel } from '@/models/SubMenuModel';

@Component
export default class MenuSelectPopup extends Vue {
  @Prop() private readonly submenus!: SubMenuModel[];

  @Prop() private readonly selectedId!: number;
}
